module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Thin.55b6f28df60a46146d2938e08137223a.woff2";